import React from "react"
import { Redirect } from "react-router-dom"
import { ConsumerCarrotRxPage } from "#/pages/consumer/carrot-rx/page"
import { DbgPaths } from "#/utils/Paths"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

// Only redirect when we've confirmed a non-consumer program. Both loading
// and errored states fall back to the spinner — a redirect to pharmacy
// while the program is unknown would send a consumer there and isn't
// idempotent from the user's POV.
export function CarrotRxRoute(): JSX.Element {
  const { data: programFlags, isLoading, isError } = useMemberProgramFlags()
  if (isLoading || isError || !programFlags) return <PageLoading />
  return programFlags.isConsumer ? <ConsumerCarrotRxPage /> : <Redirect to={DbgPaths.PHARMACY} />
}
